// PatientData Model
import { Model } from '@vuex-orm/core'

export default class PatientDentalAreaData extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'PatientDentalAreaDatas'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      id : this.attr(null),
      dtmain_area_id : this.attr(null),
      dtmain_id : this.attr(null),
      vn : this.attr(null),
      hn : this.attr(null),
      datas : this.attr(null)
    }
  }
}

